import React from 'react';
import Header from '../headers/Header';
import DynamicBreadcrumb from '../../common/DynamicBreadcrumb';
import GlobalSidebar from './GlobalSidebar';
import SidebarToggle from './SidebarToggle';
import { useSidebar } from '../../../context/SidebarContext';
import { useAuthContext } from '../../../context/Context';

const AppLayout = ({ children, footer, shapeRendering }) => {
  const { isCollapsed, isMobile, collapseSidebar } = useSidebar();
  const { loggedIn } = useAuthContext();

  // Calculate main content margin based on sidebar state and user auth status
  const getContentMargin = () => {
    if (isMobile) {
      return '0'; // No margin on mobile, sidebar overlays
    }
    if (!loggedIn) {
      return '0'; // No margin when user is not logged in (sidebar is hidden)
    }
    return isCollapsed ? '60px' : '280px'; // Adjust based on sidebar width
  };

  const contentStyle = {
    marginLeft: getContentMargin(),
    transition: 'margin-left 0.3s ease',
    minHeight: '100vh',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column'
  };

  return (
    <div className="app-layout">
      {/* Global Sidebar */}
      <GlobalSidebar />
      
      {/* Mobile Overlay */}
      {isMobile && !isCollapsed && (
        <div 
          className="sidebar-overlay"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999
          }}
          onClick={collapseSidebar}
        />
      )}
      
      {/* Main Content Area */}
      <div className="main-content-wrapper" style={contentStyle}>
        {/* Header with Sidebar Toggle */}
        <div className="header-with-toggle" style={{
          display: 'flex',
          alignItems: 'center',
          gap: loggedIn ? '10px' : '0',
          padding: '0 20px',
          backgroundColor: '#fff',
          borderBottom: '1px solid #e0e0e0',
          position: 'sticky',
          top: 0,
          zIndex: 100
        }}>
          {loggedIn && <SidebarToggle />}
          <div style={{ flex: 1 }}>
            <Header />
          </div>
        </div>
        <DynamicBreadcrumb />
        
        <div 
          className="content-wrapper js-content-wrapper overflow-hidden"
          style={{ 
            paddingTop: !loggedIn ? (isMobile ? '70px' : '80px') : '0',
            flex: 1,
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <div style={{ flex: 1 }}>
            {children}
          </div>
          {shapeRendering}
          {footer}
        </div>
      </div>
    </div>
  );
};

export default AppLayout; 